import React, { Component } from "react";
import { connect } from "react-redux";
import Sw from "./Sw";
import { changeSwModeAction, changePosTabAction, changePreTabAction, changeRsltTabAction } from "../../redux/app/actions";
import { resetCellAction as resetPlCellAction } from "../../redux/rsltPl/actions";
import { resetCellAction as resetCsCellAction } from "../../redux/csDsp/actions";
import { openSwAction, openProbAction } from "../../redux/ui/actions";

const mapStateToProps = (state) => {
    return {
        posTab: state.appReducer.posTab,
        preTab: state.appReducer.preTab,
        rsltTab: state.appReducer.rsltTab,
        csLine: state.csDspReducer.csLine,
        modelDep: state.lrnReducer.modelDep,
        plDs: state.plReducer.ds,
        csLineSw: state.uiReducer.csLineSw,
        id: state.userReducer.id,
        pass: state.userReducer.pass,
        gmUrl: state.appReducer.gmUrl,
    };
};

class TabSw extends Component {
    constructor(props) {
        super(props);
        this.changeTab = this.changeTab.bind(this);
        this.closeSw = this.closeSw.bind(this);
        this.linkGM = this.linkGM.bind(this);
    }

    /*
     * タブ変更
     * @since hara 2021-02-02
     */
    changeTab(e, action) {
        this.props.dispatch(action(e.target.value));
    }

    /*
     * IDとパスワードからジオモデラーのURLを生成する。
     * @since ando 2023-06-18
     */
    createGMURL() {
        //return '?u_id='+this.props.id+'&u_num=0&u_pass='+this.props.pass
        return "?u_id=" + "gmai" + "&u_num=0&u_pass=" + "gmai";
    }

    /*
     * サブウィンドウを閉じる
     * @since hara 2021-02-02
     */
    closeSw() {
        /*
         * 予測位置（平面）
         */
        if (this.props.ID === "pos_tab") {
            let ZValFlg = false;
            this.props.plDs.forEach((el) => {
                if (el.ZAttr === "dep") {
                    //深度の場合
                    if (el.ZVal < 0 || this.props.modelDep <= el.ZVal) ZValFlg = true;
                }
            });

            if (ZValFlg) {
                alert(`Z値は0~${parseFloat(this.props.modelDep)}の範囲で設定してください。`);
                return;
            }
        }

        /*
         * 予測表示
         */
        if (this.props.ID === "rslt_tab") {
            window.delRsltPl();
            window.hglCsLine(null);
            window.changeRsltCsSw(false);
            window.delGeoBoring();
            this.props.dispatch(resetPlCellAction());
            this.props.dispatch(resetCsCellAction());
            this.props.dispatch(openProbAction(false));
        }

        this.props.dispatch(openSwAction(null));
        this.props.dispatch(changeSwModeAction(0));
    }

    /*
     * GEOModeler連動
     * @since hara 2022-04-11
     */
    linkGM() {
        const data = {
            csLine: this.props.csLine,
            type: "line",
            userID: this.props.id,
        };

        fetch("/api/linkGM", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        }).catch((err) => {
            console.log(err.message);
        });

        //GEOModelerを開く
        window.open(this.props.gmUrl);
    }

    render() {
        let action;
        let selTab;
        switch (this.props.ID) {
            case "pos_tab":
                selTab = this.props.posTab;
                action = changePosTabAction;
                break;
            case "pre_tab":
                selTab = this.props.preTab;
                action = changePreTabAction;
                break;
            case "rslt_tab":
                selTab = this.props.rsltTab;
                action = changeRsltTabAction;
                break;
        }

        return (
            <Sw title={this.props.title} focusName={this.props.ID}>
                <input id={this.props.ID + 1} className="tab" name={this.props.ID} type="radio" value="pl" onChange={(e) => this.changeTab(e, action)} checked={selTab === "pl"} />
                <label htmlFor={this.props.ID + "1"}>平面</label>
                <input id={this.props.ID + 2} className="tab" name={this.props.ID} type="radio" value="cs" onChange={(e) => this.changeTab(e, action)} checked={selTab === "cs"} />
                <label htmlFor={this.props.ID + "2"}>断面</label>
                <fieldset className="Unit">{selTab === "pl" ? this.props.plComp : this.props.csComp}</fieldset>
                <div className="l-right l-mtM">
                    {this.props.ID === "rslt_tab" && selTab === "cs" && (
                        <button className="cBtnL" onClick={this.linkGM}>
                            GEOModeler断面連動
                        </button>
                    )}
                    <button className="cBtn l-mlS" onClick={this.closeSw}>
                        閉じる
                    </button>
                </div>
            </Sw>
        );
    }
}

export default connect(mapStateToProps)(TabSw);
